// Based off of the parent finder from Vue Leaflet
// https://github.com/vue-leaflet/Vue2Leaflet/blob/master/src/utils/utils.js
export const getMapParent = firstVueParent => {
  let found = false
  while (firstVueParent && !found) {
    if (firstVueParent.map === undefined) {
      firstVueParent = firstVueParent.$parent
    } else {
      found = true
    }
  }
  return firstVueParent
}

export function getCallback () {
  return `callback_${Math.floor(Math.random() * 1000000)}`
}

export function customEncodeURI (input) {
  return encodeURI(input)
    .replace(/&/g, '%26')
    .replace(/[+]/g, '%2B')
}

// https://stackoverflow.com/questions/22783108/convert-js-object-to-form-data
export function getFormData (data) {
  const formData = new FormData()

  buildFormData(formData, data)

  return formData
}

export function locationSort (a, b) {
  if (!isNaN(a.name.charAt(0)) && isNaN(b.name.charAt(0))) {
    return 1
  } else if (isNaN(a.name.charAt(0)) && !isNaN(b.name.charAt(0))) {
    return -1
  } else {
    return a.name.toUpperCase().localeCompare(b.name.toUpperCase())
  }
}

export function getDistance (origin, destination) {
  // return distance in meters
  var lon1 = toRadian(origin.lng || origin[1])
  var lat1 = toRadian(origin.lat || origin[0])
  var lon2 = toRadian(destination.lng || destination[1])
  var lat2 = toRadian(destination.lat || destination[0])

  var deltaLat = lat2 - lat1
  var deltaLon = lon2 - lon1

  var a = Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(deltaLon / 2), 2)
  var c = 2 * Math.asin(Math.sqrt(a))
  var EARTH_RADIUS = 6371
  return c * EARTH_RADIUS * 1000
}

export function delay (time) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

// https://stackoverflow.com/questions/141348/what-is-the-best-way-to-parse-a-time-into-a-date-object-from-user-input-in-javas
export function parseTime (t) {
  const d = new Date()
  const time = t.match(/(\d+)(?::(\d\d))?\s*(p?)/)
  d.setHours(parseInt(time[1]) + (time[3] ? 12 : 0))
  d.setMinutes(parseInt(time[2]) || 0)
  return d
}

export function get12HourTime (date) {
  const options = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  }
  return date.toLocaleTimeString('en-US', options)
}

export function sortHours (hours) {
  const order = {
    sunday: null,
    monday: null,
    tuesday: null,
    wednesday: null,
    thursday: null,
    friday: null,
    saturday: null
  }

  Object.entries(hours)
    .forEach((entry, index) => {
      const [day, hours] = entry
      order[day] = hours
    })

  return order
}

// https://gis.stackexchange.com/a/127949
// Man this is confusing...
export function getWidthInMeters (centerLat, zoom, widthInPixels) {
  return widthInPixels * 156543.03392 * Math.cos(centerLat * Math.PI / 180) / Math.pow(2, zoom)
}

function toRadian (degree) {
  return degree * Math.PI / 180
}

function buildFormData (formData, data, parentKey) {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key)
    })
  } else {
    const value = data == null ? '' : data

    if (data instanceof File) {
      formData.append(parentKey.replace(/\[[\s\S]*?\]/g, ''), value)
    } else {
      formData.append(parentKey, value)
    }
  }
}
